// @flow
import * as React from 'react'
import { handleServerSearch } from 'utils/helpers'
import { ZentakeContext } from 'utils/ZentakeContext'

function useSearchByName(): {
  handleFirstNameType: (value: string) => void,
  handleLastNameType: (value: string) => void,
} {
  const { searchClients } = React.useContext(ZentakeContext)

  const [searchFirstName, setSearchFirstName] = React.useState('')
  const [searchLastName, setSearchLastName] = React.useState('')

  const performHandleSearch = React.useCallback(async () => {
    await searchClients(
      handleServerSearch({
        firstNameTerm: searchFirstName,
        lastNameTerm: searchLastName,
        paginated: false,
      })
    )
  }, [searchClients, searchFirstName, searchLastName])

  React.useEffect(() => {
    performHandleSearch()
  }, [performHandleSearch, searchFirstName, searchLastName])

  const handleFirstNameType = (value: string) => setSearchFirstName(value)

  const handleLastNameType = (value: string) => setSearchLastName(value)

  return { handleFirstNameType, handleLastNameType }
}

export default useSearchByName
